import { Component, signal } from "@angular/core";
import { RouterOutlet } from "@angular/router";
import { NotificationComponent } from "./shared/ui-notification/notification.component";
import { ConfirmationDialogComponent } from "./shared/ui-confirmation-dialog/confirmation-dialog.component";
import { InstallPwaHintComponent } from "./shared/ui-install-pwa-hint/install-pwa-hint.component";
import { ConnectionErrorComponent } from "./shared/ui-connection-error/connection-error.component";
import { SessionEndedBannerComponent } from "./shared/ui-session-ended-banner/session-ended-banner.component";

@Component({
  selector: "app-root",
  imports: [RouterOutlet, NotificationComponent, ConfirmationDialogComponent, InstallPwaHintComponent, ConnectionErrorComponent, SessionEndedBannerComponent],
  templateUrl: "./app.html",
  styleUrl: "./app.scss",
})
export class App {
  protected readonly title = signal("zhmyak-dashboard");
}
